import {
    Box
} from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import moment from 'moment';
import { useMemo } from 'react';
import { tableConfig } from '../../../../commons/table/config/tableConfig';

const ExpiredAppointmentsTable = ({
    appointments = [],
    onSelectionChange,
    rowSelection,
}) => {

    const columns = useMemo(
        () => [
            {
                accessorKey: 'fechaHora',
                id: "fecha",
                header: 'Día',
                Cell: ({ row }) => {
                    return moment(row.original.fechaHora).format('DD/MM/YYYY');
                }
            },
            {
                accessorKey: 'fechaHora',
                id: "hora",
                header: 'Hora',
                Cell: ({ row }) => {
                    return moment(row.original.fechaHora).format('HH:mm');
                }
            },
            {
                accessorKey: 'profesionalApellidoNombre',
                header: 'Profesional',
            },
            {
                accessorKey: 'especialidadNombre',
                header: 'Especialidad',
            }
        ],
        []
    );

    const table = useMaterialReactTable({
        ...tableConfig,
        columns,
        data: appointments,
        enableRowSelection: (row) => row.original.estado == "No informados",
        enableSelectAll: true,
        onRowSelectionChange: onSelectionChange,
        state: { rowSelection, },
        initialState: {
            pagination: {
                pageSize: 5,
                pageIndex: 0,
            },
        },
        getRowId: (row) => row.idTurnoSiniestro,
        renderEmptyRowsFallback: () => (
            <Box sx={{ textAlign: 'center', py: 4 }}>
                No hay turnos vencidos
            </Box>
        ),
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableFilters: false,
    });

    return (
        <Box sx={{ width: '100%' }}>
            <MaterialReactTable table={table} />
        </Box>
    );
};

export default ExpiredAppointmentsTable;
